<template>
    <div class="well notification-wrapper">
        <div v-for="(notification, index) in list" class="panel"
        :class="{'panel-info': notification.tipo == 'Informazioni' || notification.tipo == 'Informazione', 'panel-danger': notification.tipo == 'Errore', 'panel-warning': notification.tipo == 'Avviso'}">
            <div class="media panel-heading">
                
                <div class="media-body media-middle">
                    <div v-html="notification.content" @click="openFsWindow(notification.id, notification.visual)" :style="notification.visual == 'Finestra' ? 'cursor: pointer;' : ''"></div>
                </div>
                <div v-if="notification.richiediConferma" class="media-right media-middle">
                    <button :id="'btnConfirmNotif'+notification.id" class="btn btn-default" style="background-color: transparent" @click="confirmNotification(notification.id)">{{$Jed.translate('Ok')}}</button>
                </div>
                <div v-if="notification.eliminabile" class="media-right media-middle">
                    <button class="btn btn-default" style="background-color: transparent" @click="removeNotification(notification)">{{$Jed.translate('Delete')}}</button>
                </div>
            </div>
        </div>
        <!-- SE NON CI SONO NOTIFICHE -->
        <div v-if="!list || list.length == 0" class="panel panel-default">
            <div class="media panel-heading">
                <div class="media-body media-middle">
                    <div>{{$Jed.firstUpperTranslate("there are no pending notifications")}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { eventBus } from "../../eventbus";

    export default {
        mounted: function(){
            this.initList();
        },
        created: function(){
            var vm = this;
            eventBus.$on("notificationLoop", function(){
                vm.initList()
            })
        },
        data: function(){
            return {
                list: [],
                idb: null,
                notCollection: null
            }
        },
        methods: {
            initList: function(){
                var vm = this;
                this.list = [];
                this.idb = this.$root.dataReferences;
                this.notCollection = this.idb.getCollection("userNotifications");
                this.list = this.notCollection.chain()
                                            .find({"user": this.$root.token.idUtente/* ,"richiediConferma": true */})
                                            .simplesort('start', true).data();
                /* STABILISCO IL CONTENUTO DELLA NOTIFICA: 
                * se Finestra: mostro solo l'oggetto
                * se Dialog: 
                *   * se manuale: mostro tutto il contenuto
                *   * se non manuale: compongo il contenuto con le proprietà del cmd
                *
                */
                for(var i=0; i<this.list.length; i++){
                    if(this.list[i].visual == 'Finestra'){
                        this.list[i]['content'] = this.list[i].oggetto[this.$root.token.siglaLingua]
                    }else if(this.list[i].visual == 'Dialogo'){
                        if(this.list[i].manuale){
                            vm.list[i]['content'] = this.getContent(this.list[i].id);
                        }else{
                            if(this.list[i].oggetto.cmd == 'pdf.generator.Catalog' || this.list[i].oggetto.cmd == 'pdf.generator.Order'){
                                if(this.list[i].oggetto.err){
                                    this.list[i]['content'] = this.$Jed.firstUpperTranslate('error in the print of %1$s', null, {
                                        key: null,
                                        string: [this.list[i].oggetto.arg.des]
                                    }, null)
                                }else{
                                    var pdf_link = `<a href='#' onclick='openPdf(${ JSON.stringify(this.list[i].oggetto.url) })' style="text-decoration: underline;">PDF</a>`
                                    if(this.list[i].oggetto.cmd == 'pdf.generator.Catalog'){
                                        this.list[i]['content'] = this.$Jed.firstUpperTranslate('%1$s for the print of %2$s is ready', null, {
                                            key: null,
                                            string: [pdf_link, this.list[i].oggetto.arg.des]
                                        }, null);
                                    }else if(this.list[i].oggetto.cmd == 'pdf.generator.Order'){
                                        this.list[i]['content'] = this.$Jed.firstUpperTranslate('%1$s for the print of the offer request n. %2$s is ready', null, {
                                            key: null,
                                            string: [pdf_link, this.list[i].oggetto.arg.des]
                                        }, null);
                                    }                             
                                }
                            }
                        }
                    }
                }
                this.$forceUpdate();
            },
            openFsWindow: function(id, vis){
                var ist = this.$root.fsinstances.filter(e=>{
                    return e.uuid == 'fsN-'+id
                })[0]
                if(vis == 'Finestra'){
                    ist.$refs['fsN-'+id].open()
                }
            },
            getContent: function(id){
                var contenuto = '';
                var xobj = new XMLHttpRequest();
                var url = front_end_configs.router_url + '/' + front_end_configs.notifications.pubdir + "/"  +"not_"+ id + "_" + this.$root.token.siglaLingua + ".html" 
                xobj.open('GET', url, false);
                xobj.setRequestHeader("Access-Control-Allow-Origin", '*://*/*');
                xobj.onreadystatechange = function () {
                    if (xobj.readyState == 4 && xobj.status == "200") {
                        contenuto = xobj.response
                    }
                }
                try {
                    xobj.send();
                } catch (e) {
                    alert('Problem in getting html file.')
                }
                return contenuto;
            },
            removeNotification: function(not){
                var vm = this;
                /*var ok = function(){*/
                    vm.notCollection.remove(not);
                    eventBus.$emit("notificationLoop", vm.notCollection.data.length);
                    /*this.close();*/
                /*},
                no = function(){
                    this.close();
                },
                e = {
                    message: this.$Jed.firstUpperTranslate('Do you want to delete the notification?'), 
                    ok: ok,
                    no: no
                }
                eventBus.$emit("confirm", e)*/ 
            },
            confirmNotification: function(not){
                
            }
        }
    }
</script>
<style scoped>
    .notification-wrapper {
        height: auto;
        max-height: 400px;
        overflow-y: auto;
        margin-bottom: 0px;
        padding: 10px;
        padding-bottom: 0px;
    }
    .panel {
        margin-bottom: 10px;
    }
    .panel > .panel-heading {
        border-bottom-width: medium;
        border-bottom-style: ridge;
        padding: 8px 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/others/PendingNotifications.vue?71d97b08